__turbopack_context__.v({
  "textAlignCenter": "UpdateOwnersDialog-module__O_bl4q__textAlignCenter",
  "updateOwnersDialog__item": "UpdateOwnersDialog-module__O_bl4q__updateOwnersDialog__item",
});
